import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getHomepagePath(tenant: Tenant): string {
	const pathMap = sameValueForEveryLocale("/");

	return getPathInLocale(tenant.locale, pathMap);
}
